import React from 'react'
import { Card, CardActions, CardText, CardTitle } from 'material-ui-legacy/Card'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'

import ProjectTypeSelector from '../ProjectTypes/ProjectTypeSelector'
import ValidatedTextInput from '../UI/ValidatedTextInput'
import SaveButton from '../UI/SaveButton'
import CancelButton from '../UI/CancelButton'

/*
Props:
- serviceCategory: a complete serviceCategory object
  or
- ServiceCategory fields: will be inserted in the form when present
- submitCallback: callback function called on form submission. This is *only*
  called when the form is valid and the contents have changed. Receives serviceCategory
  attributes.
- cancelCallback: callback function for the cancel button.
- changedCallback: callback function called when the form contents have changed.
  Receives true if the contents have changed.
- forceChanged: force the form status to "changed"
*/
class ServiceCategoryForm extends React.PureComponent {
  constructor(props) {
    super(props)
    // We have to build the state on a regular variable so
    // React doesn't complain about direct state mutation.
    let initialState = {
      formValid: false,
      formChanged: this.props.forceChanged || false,
      formSubmitted: false
    }

    // We can either receive a single data prop or each field separately
    this.initialData = this.props.serviceCategory
      ? this.props.serviceCategory.attributes
      : this.props

    this.fields = ['name', 'order', 'projectTypeId']
    for (let field of this.fields) {
      initialState[field] = {
        value: this.initialData[field] || '',
        valid: true
      }
    }
    this.state = initialState // Et voilà!
  }

  componentDidMount() {
    if (this.props.forceChanged) this._validateForm()
  }

  _submit = () => {
    // Don't do anything if we have invalid fields or no changes.
    if (!this.state.formValid || !this.state.formChanged) return

    let attributes = {}
    for (let field of this.fields) {
      attributes[field] = this.state[field].value
    }
    this.props.submitCallback(attributes)
    this.setState({ formChanged: false, formSubmitted: true })
  }

  _change = (value, valid, attribute) => {
    let updates = {}
    updates[attribute] = { value: value, valid: valid }
    this.setState(updates, () => {
      this._checkForChanges()
      this._validateForm()
    })
  }

  _checkForChanges = () => {
    let changed = this.props.forceChanged || false
    for (let field of this.fields) {
      let current = this.state[field].value
      let original = this.initialData[field] || ''
      if (current !== original) {
        changed = true
        break
      }
    }
    this.setState({ formChanged: changed }, () => {
      if (this.props.changedCallback) {
        this.props.changedCallback(this.state.formChanged)
      }
    })
  }

  _validateForm = () => {
    let allValid = true
    for (let field of this.fields) {
      if (!this.state[field].valid) {
        allValid = false
        break
      }
    }
    this.setState({ formValid: allValid })
  }

  render() {
    return (
      <Card>
        {this.props.formTitle && <CardTitle title={this.props.formTitle} />}
        <CardText>
          <Row>
            <Col lg="5" md="12">
              <ProjectTypeSelector
                name="projectTypeId"
                selectedIdCallback={value =>
                  this._change(value, true, 'projectTypeId')
                }
                unselectedLabel="Choose a project type"
                floatingLabelText="Project type (required)"
                value={this.state.projectTypeId.value}
                fullWidth
              />
            </Col>
            <Col lg="5" md="12">
              <ValidatedTextInput
                name="name"
                required={true}
                errorMessage="Name is required"
                hintText="Service category name"
                floatingLabelText="Name (required)"
                fullWidth={true}
                value={this.state.name.value}
                validatedOnChange={this._change}
              />
            </Col>
            <Col lg="2" md="12">
              <ValidatedTextInput
                name="order"
                required={true}
                errorMessage="Order is required"
                hintText="A number (1, 2 etc.)"
                floatingLabelText="Order (required)"
                fullWidth={true}
                pattern={/^\d+$/}
                value={this.state.order.value}
                validatedOnChange={this._change}
              />
            </Col>
          </Row>
        </CardText>

        <CardActions style={{ textAlign: 'center' }}>
          {this.props.submitCallback && (
            <SaveButton
              type="submit"
              disabled={!this.state.formChanged || !this.state.formValid}
              onTouchTap={this._submit}
            />
          )}
          {this.props.cancelCallback && (
            <CancelButton
              onTouchTap={this.props.cancelCallback}
              disabled={!this.state.formChanged && this.state.formSubmitted}
            />
          )}
        </CardActions>
      </Card>
    )
  }
}

export default ServiceCategoryForm



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/ServiceCategoryForm.jsx